import * as R from 'ramda';

export function withoutGuest(users) {
  return R.filter(u => <any>u !== '111' && <any>u !== 111, users);
}
